import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { permissions, clearPermissions } from '../../../config/permissions';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { UserService } from 'src/app/home/services/user.service';

@Component({
  selector: 'app-role-list',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink],
  templateUrl: './role-list.component.html',
  styleUrls: ['./role-list.component.scss', '../../../app.component.scss']
})
export class RoleListComponent implements OnInit{
  public searchInput: string = "";
  public encodedSearchInput: string = "";

  public permissions: any;
  public roles: any;
  public totalRoles: number = 0;

  public roleDetails: any;

  public currentRoleId: number;
  
  public isSearch = false;

  constructor(public userService: UserService, private activatedRoute: ActivatedRoute) {
    
  }

  ngOnInit(): void {
    this.permissions = permissions;
    this.getRoles();

    this.activatedRoute.queryParams.subscribe(queryParam => {
      if (queryParam.id) {
        this.onRoleChange(Number(queryParam.id))
      }
    })
  }

  getRoles(search: string = ""){
    this.userService.getRoles(['id', 'name'], search).subscribe((res)=>{
      if (res.data.length !== 0) {
        this.roles = res.data;
        this.totalRoles = this.roles.length;

        if (!this.currentRoleId) {
          this.currentRoleId = this.roles[0].id;
        }

        this.getRoleDetails(this.currentRoleId);
      }else{
        this.totalRoles = res.data.length;
      }
    })
  }

  getRoleDetails(roleId: number){
    clearPermissions('web');
    clearPermissions('hardware');

    this.userService.getRoleDetails(roleId).subscribe((res)=>{
      if (res.data) {
        this.roleDetails = res.data;
        
        if (this.roleDetails.web_permissions.length !==0 ) {
          this.permissions.web.groups.forEach(group => {
            group.permissions.forEach((permission)=>{
              if (this.roleDetails.web_permissions.includes(permission.u_name)) {
                permission.isChecked = true
              }else{
                permission.isChecked = false
              }
            })

            group.isChecked = group.permissions.some((permission) => permission.isChecked);
          });
        }

        if (this.roleDetails.hardware_permissions.length !==0 ) {
          this.permissions.hardware.groups.forEach(group => {
            group.permissions.forEach((permission)=>{
              if (this.roleDetails.hardware_permissions.includes(permission.u_name)) {
                permission.isChecked = true
              }else{
                permission.isChecked = false
              }
            })

            group.isChecked = group.permissions.some((permission) => permission.isChecked);
          });
        }
      }
    })
  }

  onRoleChange(roleId: number){
    this.currentRoleId = roleId;
    this.getRoleDetails(this.currentRoleId);
  }

  onSearchSubmit(){
    if (this.searchInput !== "") {
      this.isSearch = true;
      // if (this.isFilter) {
      //   this.createdAtSortValue = "";
      //   this.isFilter = false;
      //   this.isFilterResult = true;
      // }
      this.encodedSearchInput = encodeURIComponent(this.searchInput);
      // if (this.currentPage > 1) {
      //   this.currentPage = 1;
      //   this.paginationView.onCurrentPageChange(this.currentPage);
      // }
      this.getRoles(this.encodedSearchInput);
    }
  }

  reset(event: Event){
    event.preventDefault();
    if (this.isSearch ) {
      this.encodedSearchInput = "";
      this.searchInput = "";
      // this.createdAtSortValue = "";
      // this.selectedRoles = [];
      this.isSearch = false;
      // this.isFilter = false;
      // this.isFilterResult = true;
      // if (this.currentPage > 1) {
      //   this.currentPage = 1;
      //   this.paginationView.onCurrentPageChange(this.currentPage);
      // }
      this.getRoles();
    }
  }

  onTabClick(event: any, tabId: string){
    
    let tabLinks = document.getElementsByClassName('tab-link');
    let tabContents = document.getElementsByClassName('tab-content');
    let currentTabContent = document.getElementById(tabId);
    
    Array.from(tabContents).forEach((el)=>{
      el.classList.remove('current')
    });
    
    Array.from(tabLinks).forEach((el)=>{
      el.classList.remove('current')
    });
    
    event.target.closest('div').classList.add('current');

    currentTabContent.classList.add('current');
  }

  onGroupPermissionChecked(event: any, i: number, type: string){
    this.permissions[type].groups[i].permissions.forEach((el) => {
      el.isChecked = event.target.checked
    });
  }

  onPermissionChecked(event: any, i: number, type: string){
    let permissionGroup = this.permissions[type].groups[i];
    permissionGroup.isChecked = permissionGroup.permissions.some((permission) => permission.isChecked);
  }
}
